import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CalendarUnifiedTelemetryUtils" */ './lazyIndex'),
    { name: 'CalendarUnifiedTelemetryUtils' }
);

export const lazyCreateOpenEventUnifiedEventFromMeetingRequest: LazyImport<
    typeof lazyIndex.createOpenEventUnifiedEventFromMeetingRequest,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.createOpenEventUnifiedEventFromMeetingRequest);
